import React from 'react';
import GenericDialog from '../generic-dialog/GenericDialog';

const ConfirmationDialog = ({ isOpen, setIsOpen, isConfirmDisabled, text, onConfirm }) => {
  return (
    <GenericDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isConfirmDisabled={isConfirmDisabled}
      text={text}
      onConfirm={onConfirm}
      actionButtonCaption="Confirm"
      cancelButtonCaption="Cancel"
    />
  );
};

export default ConfirmationDialog;
